import { useCallback, useEffect, useState } from 'react';
import { CallResult } from '../../../Api/callExternalApi';

// Fetched apart from the config it decorates, so a slow or missing catalogue never holds up the form.
export const useCatalog = <T>(fetchCatalog: () => Promise<CallResult<{ fields: T[] }>>) => {
  const [fields, setFields] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    setFailed(false);
    const { data, error } = await fetchCatalog();
    setFields(data?.fields ?? []);
    setFailed(Boolean(error));
    setLoading(false);
  }, [fetchCatalog]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { fields, loading, failed, reload };
};
